import { SVGProps } from 'react';

function TrashIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.2458 5.05707C14.5113 4.78608 11.7604 4.64648 9.01772 4.64648C7.39182 4.64648 5.76592 4.7286 4.14002 4.89283L2.46484 5.05707"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.98047 4.22792L7.16112 3.15219C7.29251 2.37209 7.39105 1.78906 8.77881 1.78906H10.9303C12.318 1.78906 12.4248 2.40493 12.548 3.1604L12.7286 4.22792"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4804 7.65234L14.9466 15.9214C14.8563 17.2107 14.7824 18.2125 12.4914 18.2125H7.2195C4.92846 18.2125 4.85455 17.2107 4.76422 15.9214L4.23047 7.65234"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.48047 13.6953H11.2149"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.80078 10.4121H11.9066"
        stroke="#424242"
        strokeWidth="1.34372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TrashIcon;
